import { type ChargingScheduleVehicle } from '@/app/services/solution/types/get-charging-schedule';

const chargingScheduleVehicles: ChargingScheduleVehicle[] = [
  {
    vehicleId: 1,
    waypointId: 1,
    chassisNumber: 5_430_000,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '06:30', range: 200 },
      { type: 'Charging', time: '12:00', power: 100 },
      { type: 'Stop', time: '13:00' },
      { type: 'Driving', time: '14:00', range: 100 },
      { type: 'Charging', time: '21:00', power: 250 },
    ],
  },
  {
    vehicleId: 11,
    waypointId: 1,
    chassisNumber: 5_430_001,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '04:00' },
      { type: 'Charging', time: '11:00', power: 150 },
      { type: 'Stop', time: '12:00' },
      { type: 'Driving', time: '17:00' },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 111,
    waypointId: 1,
    chassisNumber: 5_430_002,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '05:00', range: 200 },
      { type: 'Charging', time: '12:00', power: 150 },
      { type: 'Stop', time: '13:00' },
      { type: 'Driving', time: '18:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 1111,
    waypointId: 1,
    chassisNumber: 5_430_003,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '03:00', range: 200 },
      { type: 'Charging', time: '10:00', power: 150 },
      { type: 'Stop', time: '11:00' },
      { type: 'Driving', time: '13:00', range: 200 },
      { type: 'Charging', time: '23:00', power: 150 },
    ],
  },
  {
    vehicleId: 11_111,
    waypointId: 1,
    chassisNumber: 5_430_004,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '04:00', range: 200 },
      { type: 'Charging', time: '9:00', power: 150 },
      { type: 'Stop', time: '10:00' },
      { type: 'Driving', time: '13:00', range: 200 },
      { type: 'Charging', time: '18:00', power: 150 },
    ],
  },
  {
    vehicleId: 111_111,
    waypointId: 1,
    chassisNumber: 5_430_005,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '03:00', range: 200 },
      { type: 'Charging', time: '11:00', power: 150 },
      { type: 'Stop', time: '12:00' },
      { type: 'Driving', time: '15:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 1_111_111,
    waypointId: 1,
    chassisNumber: 5_430_006,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '04:00', range: 200 },
      { type: 'Charging', time: '10:00', power: 150 },
      { type: 'Stop', time: '11:00' },
      { type: 'Driving', time: '12:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 11_111_111,
    waypointId: 1,
    chassisNumber: 5_430_007,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Charging', time: '12:00', power: 150 },
      { type: 'Stop', time: '13:00' },
      { type: 'Driving', time: '15:00', range: 200 },
      { type: 'Charging', time: '21:00', power: 150 },
    ],
  },
  {
    vehicleId: 111_111_111,
    waypointId: 1,
    chassisNumber: 5_430_008,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '03:00', range: 200 },
      { type: 'Charging', time: '11:00', power: 150 },
      { type: 'Stop', time: '13:00' },
      { type: 'Driving', time: '17:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 2,
    waypointId: 2,
    chassisNumber: 4_814_988,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Stop', time: '13:00' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 22,
    waypointId: 2,
    chassisNumber: 5_430_001,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '04:00', range: 200 },
      { type: 'Charging', time: '11:00', power: 150 },
      { type: 'Stop', time: '12:00' },
      { type: 'Driving', time: '17:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 222,
    waypointId: 2,
    chassisNumber: 5_430_002,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '05:00', range: 200 },
      { type: 'Charging', time: '12:00', power: 150 },
      { type: 'Stop', time: '13:00' },
      { type: 'Driving', time: '18:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 2222,
    waypointId: 2,
    chassisNumber: 5_430_003,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '03:00', range: 200 },
      { type: 'Charging', time: '10:00', power: 150 },
      { type: 'Stop', time: '11:00' },
      { type: 'Driving', time: '13:00', range: 200 },
      { type: 'Charging', time: '23:00', power: 150 },
    ],
  },
  {
    vehicleId: 22_222,
    waypointId: 1,
    chassisNumber: 5_430_004,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '04:00', range: 200 },
      { type: 'Charging', time: '9:00', power: 150 },
      { type: 'Stop', time: '10:00' },
      { type: 'Driving', time: '13:00', range: 200 },
      { type: 'Charging', time: '18:00', power: 150 },
    ],
  },
  {
    vehicleId: 222_222,
    waypointId: 2,
    chassisNumber: 5_430_005,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '03:00', range: 200 },
      { type: 'Charging', time: '11:00', power: 150 },
      { type: 'Stop', time: '12:00' },
      { type: 'Driving', time: '15:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 2_222_222,
    waypointId: 2,
    chassisNumber: 5_430_005,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '05:00', range: 200 },
      { type: 'Charging', time: '10:00', power: 150 },
      { type: 'Stop', time: '11:00' },
      { type: 'Driving', time: '18:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 3,
    waypointId: 3,
    chassisNumber: 8_122_321,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '04:00', range: 200 },
      { type: 'Stop', time: '10:00' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '21:00', power: 150 },
    ],
  },
  {
    vehicleId: 33,
    waypointId: 3,
    chassisNumber: 5_430_001,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Charging', time: '10:00', power: 150 },
      { type: 'Stop', time: '14:00' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 333,
    waypointId: 3,
    chassisNumber: 5_430_002,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '05:00', range: 200 },
      { type: 'Charging', time: '12:00', power: 150 },
      { type: 'Stop', time: '13:00' },
      { type: 'Driving', time: '18:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 4,
    waypointId: 4,
    chassisNumber: 9_984_121,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Stop', time: '11:00' },
      { type: 'Charging', time: '13:00', power: 150 },
      { type: 'Stop', time: '15:00' },
      { type: 'Charging', time: '16:30', power: 150 },
      { type: 'Stop', time: '19:00' },
      { type: 'Driving', time: '20:00', range: 200 },
      { type: 'Charging', time: '21:00', power: 150 },
    ],
  },
  {
    vehicleId: 44,
    waypointId: 4,
    chassisNumber: 5_430_005,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '03:00', range: 200 },
      { type: 'Charging', time: '11:00', power: 150 },
      { type: 'Stop', time: '12:00' },
      { type: 'Driving', time: '15:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 444,
    waypointId: 4,
    chassisNumber: 5_430_005,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '09:00', range: 200 },
      { type: 'Charging', time: '14:00', power: 150 },
      { type: 'Stop', time: '15:00' },
      { type: 'Driving', time: '17:00', range: 200 },
      { type: 'Charging', time: '20:00', power: 150 },
    ],
  },
  {
    vehicleId: 5,
    waypointId: 5,
    chassisNumber: 5_438_853,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Charging', time: '12:00', power: 150 },
      { type: 'Stop', time: '14:00' },
      { type: 'Charging', time: '17:00', power: 150 },
      { type: 'Driving', time: '20:00', range: 200 },
      { type: 'Charging', time: '21:00', power: 150 },
    ],
  },
  {
    vehicleId: 55,
    waypointId: 5,
    chassisNumber: 5_430_001,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '04:00', range: 200 },
      { type: 'Charging', time: '11:00', power: 150 },
      { type: 'Stop', time: '12:00' },
      { type: 'Driving', time: '17:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 555,
    waypointId: 5,
    chassisNumber: 5_430_001,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Charging', time: '09:00', power: 150 },
      { type: 'Stop', time: '14:00' },
      { type: 'Driving', time: '13:00', range: 200 },
      { type: 'Charging', time: '22:00', power: 150 },
    ],
  },
  {
    vehicleId: 6,
    waypointId: 6,
    chassisNumber: 8_122_321,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Stop', time: '11:00' },
      { type: 'Charging', time: '14:30', power: 150 },
      { type: 'Stop', time: '16:30' },
      { type: 'Driving', time: '20:30', range: 200 },
      { type: 'Charging', time: '23:00', power: 150 },
    ],
  },
  {
    vehicleId: 7,
    waypointId: 7,
    chassisNumber: 8_122_322,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '05:00', range: 200 },
      { type: 'Stop', time: '11:00' },
      { type: 'Stop', time: '12:00' },
      { type: 'Charging', time: '14:30', power: 150 },
      { type: 'Stop', time: '16:30' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '20:00', power: 150 },
    ],
  },
  {
    vehicleId: 8,
    waypointId: 8,
    chassisNumber: 8_122_322,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '05:00', range: 200 },
      { type: 'Stop', time: '11:00' },
      { type: 'Stop', time: '12:00' },
      { type: 'Charging', time: '14:30', power: 150 },
      { type: 'Stop', time: '16:30' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '20:00', power: 150 },
    ],
  },
  {
    vehicleId: 88,
    waypointId: 8,
    chassisNumber: 8_122_323,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Stop', time: '14:00' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '20:00', power: 150 },
    ],
  },
  {
    vehicleId: 9,
    waypointId: 9,
    chassisNumber: 8_122_322,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '05:00', range: 200 },
      { type: 'Stop', time: '11:00' },
      { type: 'Stop', time: '12:00' },
      { type: 'Charging', time: '14:30', power: 150 },
      { type: 'Stop', time: '16:30' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '20:00', power: 150 },
    ],
  },
  {
    vehicleId: 10,
    waypointId: 10,
    chassisNumber: 8_122_322,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '05:00', range: 200 },
      { type: 'Stop', time: '11:00' },
      { type: 'Stop', time: '12:00' },
      { type: 'Charging', time: '14:30', power: 150 },
      { type: 'Stop', time: '16:30' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '20:00', power: 150 },
    ],
  },
  {
    vehicleId: 100,
    waypointId: 10,
    chassisNumber: 8_122_322,
    chargingScheduleItems: [
      { type: 'Charging', time: '00:00', power: 150 },
      { type: 'Driving', time: '07:00', range: 200 },
      { type: 'Stop', time: '13:00' },
      { type: 'Stop', time: '14:00' },
      { type: 'Charging', time: '15:00', power: 150 },
      { type: 'Stop', time: '16:30' },
      { type: 'Driving', time: '19:00', range: 200 },
      { type: 'Charging', time: '21:00', power: 150 },
    ],
  },
];

export default chargingScheduleVehicles;
